import React from 'react'
import { FaqStyled, FaqTitle } from './Faq.styled'
import { useTranslation } from 'react-i18next'
import { Accordion } from '@clickcease/cc-client-components-lib'
import { isMobile } from 'react-device-detect'

type FaqProps = {
  bundle: boolean
}

export const Faq = ({ bundle }: FaqProps) => {
  const { t } = useTranslation('pricing')

  const items = [
    {
      title: t('faq.q1_title'),
      content: t('faq.q1_answer'),
    },
    {
      title: t('faq.q2_title'),
      content: t('faq.q2_answer'),
    },
    {
      title: t('faq.q3_title'),
      content: t('faq.q3_answer'),
    },
    {
      title: t('faq.q4_title'),
      content: t('faq.q4_answer'),
    },
    {
      title: t('faq.q5_title'),
      content: t('faq.q5_answer'),
    },
  ]

  return (
    <FaqStyled bundleMobile={bundle && isMobile}>
      <FaqTitle>{t('faq.title')}</FaqTitle>
      <Accordion items={items} />
    </FaqStyled>
  )
}
